// Added by Sejune Oh on 2019-02-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { createStyles, withStyles, Theme, WithStyles, WithTheme } from '@material-ui/core'
import classNames from 'classnames'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Define
import { ReactInputChangeEvent, ReactEmptyEvent, ReactKeyUpEvent, ReactKeyPressEvent } from '@/helper/define'

// Intl
import Intl from '@/helper/Intl'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime element
import { Paper, IconButton, InputBase, SearchIcon, Button } from '@/components/_primes'
import { GREY_COLOR } from '@/styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
export interface SearchBaseFCProps {
    defaultValue?: string
    autocomplete?: boolean
    hideBtn?: boolean
}
interface SearchFCProps extends SearchBaseFCProps, WithStyles<typeof styles>, WithTheme {
    onBtnClick: ReactEmptyEvent
    onChange: ReactInputChangeEvent
    onKeyUp: ReactKeyUpEvent
    onKeyPress: ReactKeyPressEvent
    btnId: string
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const Search = (props: SearchFCProps) => {
    const { classes } = props

    return (
        <div className={classes.SearchWrapper}>
            <Paper
                className={classNames(classes.SearchPaper, props.hideBtn ? classes.SearchWithHideBtn : '')}
                elevation={1}
            >
                <InputBase
                    id={'search-input'}
                    className={classes.SearchInput}
                    onChange={props.onChange}
                    onKeyPress={props.onKeyPress}
                    onKeyUp={props.onKeyUp}
                    defaultValue={props.defaultValue || ''}
                    autoComplete={props.autocomplete ? 'on' : 'off'}
                    inputProps={{
                        'data-cy-input' : 'search-input',
                        'data-testid': 'search-input',
                    }}
                />
                <IconButton className={classes.SearchIconButton} aria-label="Search" data-cy-btn="search-btn" data-testid="search-btn">
                    <SearchIcon />
                </IconButton>
            </Paper>
            {!props.hideBtn && <Button
                id={props.btnId}
                className={classes.SearchBtn}
                color={'primary'}
                onClick={props.onBtnClick}
                btnText={Intl.getIntlText({ id: 'htmljs_react.component.search.btn_search' })}
                hidden={props.hideBtn}
            />}
        </div>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        SearchWrapper: {
            display: 'flex',
            width: '100%',
            // marginTop: '24px',
        },
        SearchPaper: {
            padding: '2px 4px',
            display: 'inline-flex',
            alignItems: 'center',
            flexBasis: '100%',
            marginRight: '15px',

            /* Aview Common Style */
            backgroundColor: `${GREY_COLOR}`,
            // borderRadius: 0,
            // boxShadow: 'none',
        },
        SearchWithHideBtn: {
            marginRight: 0,
        },
        SearchInput: {
            marginLeft: 8,
            flex: 1,
        },
        SearchIconButton: {
            padding: 4,
        },
        SearchBtn: {
            display: 'inline-flex',
        },
    })

export default withStyles(styles, { withTheme: true })(Search)
